import { FC } from 'react'
import { ReactComponent as AppStoreIcon } from 'src/assets/svg/app-store.svg'
import { ReactComponent as BookingIcon } from 'src/assets/svg/Booking.com_Icon_2022.svg 1.svg'
import { ReactComponent as ExpediaIcon } from 'src/assets/svg/Frame 427323565.svg'
import { ReactComponent as GoogleIcon } from 'src/assets/svg/material-icon-theme_google.svg'
import { ReactComponent as GooglePlayIcon } from 'src/assets/svg/google-play.svg'
import { ReactComponent as TripadvisorIcon } from 'src/assets/svg/tripadvisor.svg'
import { ReviewPlatform } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

type PlatformIcon = FC<React.SVGProps<SVGSVGElement>>

const PLATFORM_ICONS: Record<ReviewPlatform, PlatformIcon> = {
  appstore: AppStoreIcon,
  booking: BookingIcon,
  expedia: ExpediaIcon,
  google: GoogleIcon,
  playstore: GooglePlayIcon,
  tripadvisor: TripadvisorIcon,
}

export const getPlatformIcon = (platform: ReviewPlatform): PlatformIcon =>
  PLATFORM_ICONS[platform] ?? GoogleIcon
